
      var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReportManagement = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 32H6.6A1.6 1.6 0 0 1 5 30.4V9.6A1.6 1.6 0 0 1 6.6 8h30.8A1.6 1.6 0 0 1 39 9.6V17M28 38H16",
  stroke: "#000",
  strokeWidth: 1.71,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 34.25,
  cy: 25.25,
  r: 5.75,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.043 33.457a1 1 0 0 0 1.414-1.414l-.707.707-.707.707Zm.707-.707.707-.707-3-3-.707.707-.707.707 3 3 .707-.707Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M27.5 32L6.6 32C5.71634 32 5 31.2837 5 30.4V9.6C5 8.71634 5.71634 8 6.6 8L37.4 8C38.2837 8 39 8.71634 39 9.6V17\" stroke=\"black\" stroke-width=\"1.71\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M28 38H16\" stroke=\"black\" stroke-width=\"1.71\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"34.25\" cy=\"25.25\" r=\"5.75\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\"/>\r\n<path d=\"M41.0429 33.4571C41.4334 33.8476 42.0666 33.8476 42.4571 33.4571C42.8476 33.0666 42.8476 32.4334 42.4571 32.0429L41.75 32.75L41.0429 33.4571ZM41.75 32.75L42.4571 32.0429L39.4571 29.0429L38.75 29.75L38.0429 30.4571L41.0429 33.4571L41.75 32.75Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/reportManagement.487bd1ad7ca93b2f24b7c0b02f8233bf.svg"),
        {
          React: SvgReportManagement,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      